import Vue from 'vue'
import Vuex, { Store } from 'vuex'

import app, { App } from './modules/app'
import menu, { Menu } from './modules/menu'
import asn, { Asn } from './modules/asn'

import tagsView from './modules/tagsView'

import getters from './getters'

Vue.use(Vuex)

export interface State {
  app: App;
  menu: Menu;
  asn: Asn;
}

const store: Store<State> = new Vuex.Store({
  modules: { app, menu, asn, tagsView },
  getters
})

export default store
